import { inheritsLoose as _inheritsLoose, extends as _extends, objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from './_virtual/_rollupPluginBabelHelpers.js';
import { createElement, Component } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import { get404Component, getAllRoutes, isInstantTransition } from './utils.esm.js';
import { loadInitialProps } from './loadInitialProps.esm.js';
import { loadStaticProps } from './loadStaticProps.esm.js';

var _excluded = ["location", "history", "routes", "data", "transitionBehavior", "match", "staticContext", "children"];

var Afterparty = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Afterparty, _React$Component);

  function Afterparty() {
    var _this;

    _this = _React$Component.apply(this, arguments) || this;
    _this.state = {
      data: _this.props.data.initialData,
      previousLocation: null,
      currentLocation: _this.props.location,
      isLoading: false
    };
    _this.prefetcherCache = {};
    _this.NotfoundComponent = get404Component(_this.props.routes);

    _this.prefetch = function (pathname) {
      var ssg = _this.props.data.afterData.ssg; // in ssg mode we don't call component.getInitialProps
      // instead we fetch the page-data.json file

      var loadData = ssg ? loadStaticProps : loadInitialProps;
      loadData(pathname, _this.props.routes, {
        history: _this.props.history
      }).then(function (_ref) {
        var _extends2;

        var data = _ref.data;
        _this.prefetcherCache = _extends({}, _this.prefetcherCache, (_extends2 = {}, _extends2[pathname] = data, _extends2));
      })["catch"](function (e) {
        return console.log(e);
      });
    };

    return _this;
  }

  Afterparty.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    var currentLocation = props.location;
    var previousLocation = state.currentLocation;
    var navigated = currentLocation !== previousLocation;

    if (navigated) {
      return {
        previousLocation: state.previousLocation || previousLocation,
        currentLocation: currentLocation,
        isLoading: true
      };
    }

    return null;
  };

  var _proto = Afterparty.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(_prevProps, prevState) {
    var _this2 = this;

    var navigated = prevState.currentLocation !== this.state.currentLocation;

    if (navigated) {
      var _this$props = this.props,
          location = _this$props.location,
          history = _this$props.history,
          routes = _this$props.routes,
          data = _this$props.data,
          transitionBehavior = _this$props.transitionBehavior,
          rest = _objectWithoutPropertiesLoose(_this$props, _excluded);

      var _data$afterData = data.afterData,
          scrollToTop = _data$afterData.scrollToTop,
          ssg = _data$afterData.ssg;
      var isInstantMode = isInstantTransition(transitionBehavior);
      var isBloackedMode = !isInstantMode;

      var ctx = _extends({
        location: location,
        history: history,
        scrollToTop: scrollToTop
      }, rest); // Only for page changes, prevent scroll up for anchor links


      var isPageChanged = !!prevState.currentLocation && prevState.currentLocation.pathname !== location.pathname;
      var isAllowedToScroll = isPageChanged && scrollToTop.current === true; // in instant mode, first we scroll to top then we fetch the data

      if (isInstantMode && isAllowedToScroll) {
        window.scrollTo(0, 0);
      } // in ssg mode we don't call component.getInitialProps
      // instead we fetch the page-data.json file


      var loadData = ssg ? loadStaticProps : loadInitialProps;
      loadData(location.pathname, routes, ctx).then(function (res) {
        return res.data;
      }).then(function (data) {
        // if user moved to a new page at the time we were fetching data
        // for the previous page, we ignore data of the previous page
        if (_this2.state.currentLocation !== location) return; // in blocked mode, first we fetch the data and then we scroll to top

        if (isBloackedMode && isAllowedToScroll) {
          window.scrollTo(0, 0);
        }

        _this2.setState({
          previousLocation: null,
          data: data,
          isLoading: false
        });
      })["catch"](function (e) {
        // @todo we should more cleverly handle errors???
        console.log(e);
      });
    }
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$state = this.state,
        previousLocation = _this$state.previousLocation,
        data = _this$state.data,
        isLoading = _this$state.isLoading;
    var _this$props2 = this.props,
        currentLocation = _this$props2.location,
        transitionBehavior = _this$props2.transitionBehavior;
    var initialData = this.prefetcherCache[currentLocation.pathname] || data;
    var instantMode = isInstantTransition(transitionBehavior); // when we are in the instant mode we want to pass the right location prop
    // to the <Route /> otherwise it will render previous matche component

    var location = instantMode ? currentLocation : previousLocation || currentLocation;
    return createElement(Switch, {
      location: location
    }, (initialData == null ? void 0 : initialData.statusCode) === 404 && createElement(Route, {
      component: this.NotfoundComponent,
      path: location.pathname
    }), (initialData == null ? void 0 : initialData.redirectTo) && createElement(Redirect, {
      to: initialData.redirectTo
    }), getAllRoutes(this.props.routes).map(function (r, i) {
      return createElement(Route, {
        key: "route--" + i,
        path: r.path,
        exact: r.exact,
        render: function render(props) {
          return createElement(r.component, _extends({}, initialData, {
            history: props.history,
            match: props.match,
            prefetch: _this3.prefetch,
            location: location,
            isLoading: isLoading
          }));
        }
      });
    }));
  };

  return Afterparty;
}(Component);

Afterparty.defaultProps = {
  transitionBehavior: 'blocking'
};
var After = /*#__PURE__*/withRouter(Afterparty);

export { After };
//# sourceMappingURL=After.esm.js.map
